export default [
  {
    name: 'raio-x-empresa',
    path: '/raioxEmpresa',
    component: () => import('@/app/raio-x-empresa/RaioXEmpresaView.vue'),
    meta: {
      // Acesso somente com usuario logado. O 'monitorcontabil' em action e o atalho
      // do canNavigate para liberar a qualquer usuario autenticado, sem exigir
      // permissao propria no CASL (mesmo padrao do dashboard inicial).
      resource: '',
      action: 'monitorcontabil',
      requiredAuth: true,
      layout: 'full',
      pageTitle: 'Raio-X Fiscal',
    },
  },
]
